/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Mk_Price_ChooseInputs */

const en_mk_price_choose = /** @type {(inputs: Mk_Price_ChooseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Explore ${i?.name}`)
};

const id_mk_price_choose = /** @type {(inputs: Mk_Price_ChooseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lihat paket ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Explore {name}" |
*
* @param {Mk_Price_ChooseInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_price_choose = /** @type {((inputs: Mk_Price_ChooseInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Price_ChooseInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_price_choose(inputs)
	return en_mk_price_choose(inputs)
});